import React, { useEffect, useState } from 'react';
import { UIKitProvider } from '@ui-kit-ngs/providers';
import { ThemeProvider } from '@emotion/react';
import { getTheme, ThemeV4 } from '@ui-kit-ngs/theme';
import { fetchData } from '../data-providers';
import { useOddsFormat, usePlacedBets, useSelectionsInBetslip } from '../hooks';
import { Carousel } from './Carousel';
import { StyledSectionHeader, StyledSectionHeaderContent, StyledSectionHeaderLabel } from './styled-components';
export const EpicValueCarousel = ({ dataUrl, showSectionHeader, sectionTitle, backgroundColor = 'white', navigate, device, locale, deepLinkUrl, }) => {
    const [rawData, setRawData] = useState(null);
    const [filteredData, setData] = useState([]);
    const oddsFormat = useOddsFormat();
    const placedBets = usePlacedBets();
    const selectionsInBetslip = useSelectionsInBetslip();
    useEffect(() => {
        const setRawCardsItems = async () => {
            const data = (await fetchData(dataUrl));
            if (data)
                setRawData(data);
        };
        setRawCardsItems();
    }, [dataUrl]);
    useEffect(() => {
        if (rawData) {
            setData(rawData.epicValueCards.filter((c) => !placedBets.includes(c.selectionId.replace('OB_OU', ''))));
        }
    }, [rawData, placedBets]);
    if (!(filteredData && filteredData.length))
        return null;
    const carouselComponent = (React.createElement(Carousel, { cards: filteredData, navigate: navigate, selectionsInBetslip: selectionsInBetslip, oddsFormat: oddsFormat, maxLimit: rawData.carouselLimit, device: device, deepLinkUrl: deepLinkUrl }));
    //Override for Carousel background
    const themeVersion = ThemeV4;
    themeVersion.colors.backgrounds.primaryNavigation.background = backgroundColor;
    const theme = getTheme({ device: device, themeOverride: themeVersion });
    return (React.createElement(UIKitProvider, { locale: locale },
        React.createElement(ThemeProvider, { theme: theme }, showSectionHeader ? (React.createElement(StyledSectionHeader, null,
            React.createElement(StyledSectionHeaderLabel, null, sectionTitle || 'Featured Markets'),
            React.createElement(StyledSectionHeaderContent, null, carouselComponent))) : (carouselComponent))));
};
